export const ROLES_PATH = "/apps/roles";
export const PERMISSIONS_PATH = "/apps/permissions";
